var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalDetail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38666 0.153193C7.26134 0.432894 6.4051 0.928124 5.46757 1.84142C2.84526 4.39646 3.84622 8.4389 7.48844 10.0041C8.68738 10.5194 10.8226 10.5765 12.1813 10.1298C13.5341 9.68496 14.8442 8.59449 15.4788 7.38474C16.0863 6.22727 16.1555 4.69619 15.6579 3.43073C15.2378 2.3631 13.853 1.03033 12.6098 0.497537C11.4634 0.00622028 9.59204 -0.14623 8.38666 0.153193ZM6.66848 11.9118C4.45677 12.3816 2.08586 13.9722 1.03076 15.6941C0.152188 17.1277 -0.292369 19.3551 0.211867 19.7968C0.521162 20.0677 19.4859 20.0677 19.7952 19.7968C20.0895 19.539 20.0639 18.5115 19.7357 17.4075C18.9265 14.6859 16.2266 12.4374 13.077 11.862C11.8255 11.6335 7.83276 11.6643 6.66848 11.9118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetail);
export default __webpack_public_path__ + "static/media/personal-detail.ab33b98c70e62f1a814e766601e6518f.svg";
export { ForwardRef as ReactComponent };